import React, { useState, useEffect } from "react";
import { Icon, Image, Divider, Header } from 'semantic-ui-react'
import image1 from "../../../assets/locations/anisa.jpg"
const Point22 = () => {
    return (
    <React.Fragment>
      <p>
      У Аинса басену, шпански Пиринеји, извађена су језгра дуга 230 метара, од којих 150 метара припада слоју средњег еоцена сачињеног од дубокоморских силикластичних седимената. Узорци из тог дела језгра подвргнути су различитим анализама како би се утврдиле промене природног окружења у та давна времена. Циклостратиграфска анализа језгра открила је Миланковићеву цикличност на фреквенцама од  ~0,03 циклуса/м („кратка“ промена ексцентричности), од ~0,09 циклуса/м (промена нагиба осе), ~0,15 цилуса/м (прецесија) и ~0,19 циклуса/м (прецесија). Показало се да орбитални параметри контролишу циклично депоновање крупнозрних седиманата подводним силазним струјањем приобалних вода. Ове цикличне промене дубокоморских седимената могу да објасне два веродостојна модела депоновања, оба покретана Миланковићевим циклусима: (1) климатски циклуси са влажним периодима повишене хемијске ваздушне абразије, јачи ветрови и олује, а тиме јаче спирање и транспорт воденим токовима доводили су до великог уноса песковитих седимената у дубоки басен подводним струјама; (2) климатски цилуси, са хладнијим условима у вези са високофреквентним еустатичким флуктуацијама морског нивоа, и са плитким шелфовима речних делти резултовали су већом количином грубог детриталног седимента допреманих на морско дно хиперпикналним токовима. Ова студија пружа увид у то како промена климе изазвана орбиталним чиниоцима утиче на таложење седимената и на допремање материјала са копна у дубокоморску средину. 
      </p>
      <Divider horizontal>
        <Header as="h4">
        <Icon name='image' />
        Fotgorafija
        </Header>      
      </Divider>
      <Image src={image1} alt="BASEN AINSA, ŠPANJOLSKI PIRINEJI" fluid />
      

    </React.Fragment>
    )
  }

  export default Point22;

